export default "__VITE_ASSET__HJnuLRqN__"